class AboutDialog extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this);
    this.addEventListener('close', this, true);
  }

  handleEvent(event) {
    if (event.type === 'close') return this.handleClose(event.target);

    const { target } = event;
    const opener = target.closest('[data-dialog-open]');
    if (opener) {
      event.preventDefault();
      return this.open(opener);
    }
    if (target.closest('[data-dialog-close]') || target.matches('dialog')) target.closest('dialog').close();
  }

  open(opener) {
    const dialog = document.getElementById(opener.dataset.dialogOpen);
    const { videoSrc, videoPoster, dialogTitle } = opener.dataset;
    this.opener = opener;

    if (videoSrc) {
      const video = dialog.querySelector('video');
      dialog.querySelector('[data-dialog-title]').textContent = dialogTitle;
      video.poster = videoPoster ?? '';
      video.src = videoSrc;
      video.play().catch(() => {});
    }
    dialog.showModal();
  }

  handleClose(dialog) {
    const video = dialog.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    this.opener?.focus({ preventScroll: true });
  }
}

if (!customElements.get('about-dialog')) customElements.define('about-dialog', AboutDialog);
